import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GlobalStyles  from "./styles/GlobalStyles";
import ScrollToTop   from "./components/ScrollToTop";
import Navbar        from "./components/Navbar";
import Footer        from "./components/Footer";
import HomePage      from "./pages/Home";
import PackagesPage  from "./pages/Packages";
import PackageDetailsPage from "./pages/PackageDetails";
import DestinationsPage from "./pages/Destinations";
import AboutPage     from "./pages/About";
import ContactPage   from "./pages/Contact";

const App = () => {
  const { i18n } = useTranslation();

  // Apply RTL direction when Arabic is selected
  useEffect(() => {
    const dir = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <>
    <BrowserRouter>
      <GlobalStyles />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/"             element={<HomePage />} />
          <Route path="/packages"     element={<PackagesPage />} />
          <Route path="/packages/:id" element={<PackageDetailsPage />} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/about"        element={<AboutPage />} />
          <Route path="/contact"      element={<ContactPage />} />
          <Route path="*"             element={<HomePage />} />
        </Routes>
      </main>
      <Footer />
      </BrowserRouter>
    </>
  );
};

export default App;
 
